import { FORGOT_PASSWORD } from 'client/redux/forgotPassword/constants';
import * as actionCreators from 'client/redux/forgotPassword/actionCreators';

export const forgotPassword = form => dispatch => {
  return dispatch(actionCreators.forgotPassword(FORGOT_PASSWORD, form));
};
